import { ReactNode } from "react";
import {
  FieldValues,
  FormProvider,
  UseFormHandleSubmit,
  UseFormReturn,
} from "react-hook-form";

type HandleSubmitParams<
  TFieldValues extends FieldValues,
  TTransformedValues extends FieldValues | undefined = undefined,
> = Parameters<UseFormHandleSubmit<TFieldValues, TTransformedValues>>;

export interface FormProps<
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  TTransformedValues extends FieldValues | undefined = undefined,
> extends UseFormReturn<TFieldValues, TContext, TTransformedValues> {
  children: ReactNode;
  className?: string;
  onSubmitValid: HandleSubmitParams<TFieldValues, TTransformedValues>[0];
  onSubmitInvalid?: HandleSubmitParams<TFieldValues, TTransformedValues>[1];
}

export const Form = <
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  TTransformedValues extends FieldValues | undefined = undefined,
>({
  children,
  onSubmitValid,
  onSubmitInvalid,
  className,
  ...formProps
}: FormProps<TFieldValues, TContext, TTransformedValues>) => {
  const { handleSubmit } = formProps;

  return (
    <FormProvider {...formProps}>
      <form
        aria-label="form"
        onSubmit={handleSubmit(onSubmitValid, onSubmitInvalid)}
        className={className}
      >
        {children}
      </form>
    </FormProvider>
  );
};
